import { useEffect } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import { useScrollToHash } from '@/hooks/useScrollToHash';
import { injectBreadcrumbSchema } from '@/utils/structuredData';
import { applyPageSeo } from '@/utils/seo';
import Hero from './components/Hero';
import JournalStats from './components/JournalStats';
import MonthlyPerformance from './components/MonthlyPerformance';
import RecordPurpose from './components/RecordPurpose';
import TradeTable from './components/TradeTable';
import TesterReport from './components/TesterReport';

const pageTitle = 'Trade Journal | XAUUSD MT5 EA Trade Records | GoldEA';
const pageDescription =
  'The full recorded trade journal for GoldEA. Filter every XAUUSD entry by direction and outcome, with monthly performance and complete risk data for each trade.';
const pageKeywords =
  'XAUUSD trade journal, gold trading records, MT5 EA performance, trade history, risk disclosure';

export default function TradeJournal() {
  useScrollToHash();

  useEffect(() => {
    const removeSeo = applyPageSeo({
      title: pageTitle,
      description: pageDescription,
      keywords: pageKeywords,
      path: '/trade-journal',
    });
    const removeBreadcrumb = injectBreadcrumbSchema('Trade Journal', '/trade-journal');
    return () => {
      removeSeo();
      removeBreadcrumb();
    };
  }, []);

  return (
    <div className="w-full min-h-screen bg-background-50">
      <SiteHeader current="trade-journal" />
      <main>
        <Hero />
        <JournalStats />
        <MonthlyPerformance />
        <RecordPurpose />
        <TradeTable />
        <TesterReport />
      </main>
      <SiteFooter current="trade-journal" />
    </div>
  );
}